import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

import { cn } from '@epoch-ui/lib/utils';

interface CheckboxProps extends CheckboxPrimitive.CheckboxProps {
  error?: boolean;
}

const Checkbox = React.forwardRef<React.ElementRef<typeof CheckboxPrimitive.Root>, CheckboxProps>(
  ({ className, error, ...props }, ref) => (
    <CheckboxPrimitive.Root
      ref={ref}
      className={cn(
        'tw-peer tw-h-4 tw-w-4 tw-shrink-0 tw-rounded-sm tw-border tw-border-solid tw-border-primary tw-ring-offset-background focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-0 disabled:tw-cursor-not-allowed disabled:tw-opacity-50 data-[state=checked]:tw-bg-primary data-[state=checked]:tw-text-primary-foreground',
        !error && 'data-[state=unchecked]:tw-border-input',
        error && 'tw-border-negative-red',
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        className={cn('tw-flex tw-items-center tw-justify-center tw-text-current')}
      >
        <FontAwesomeIcon className="tw-text-[0.7rem]" icon={faCheck} fixedWidth />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
);
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
export type { CheckboxProps };
